export default "__VITE_ASSET__CBgXjzre__"